import { render, staticRenderFns } from "./ProductComments.vue?vue&type=template&id=1b0fa9f2&scoped=true&"
import script from "./ProductComments.vue?vue&type=script&lang=js&"
export * from "./ProductComments.vue?vue&type=script&lang=js&"
import style0 from "./ProductComments.vue?vue&type=style&index=0&id=1b0fa9f2&lang=scss&scoped=true&"
import style1 from "./ProductComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0fa9f2",
  null
  
)

export default component.exports